import React from 'react'
import {useDisplayNumber} from '../../../utils/number'
import ContainerLayout from '../../../components/layout/ContainerLayout'
import TableHeader from '../../../components/table/TableHeader'
import Text from '../../../components/text/Text'
import {IOpenOrder} from '../../../apis/types/portfolio'
import TableItem from '../../../components/table/TableItem'
import WizImage from '../../../components/image/WizImage'
import Span from '../../../components/text/Span'

interface IProps {
    className?: string
    data?: IOpenOrder[]
}

const OpenOrderContainer: React.FC<IProps> = ({className, data}) => {
    const {renderPercent, floorBalance, displayAmount} = useDisplayNumber()

    return (
        <ContainerLayout title={'Open Order'} className={`shadow-none  sm:text-center sm:space-y-[20px] ${className}`}>
            <TableHeader className={'grid-cols-[1fr_130px_100px_170px] md:hidden'}>
                <Text>Symbol</Text>
                <Text>Type</Text>
                <Text>
                    Price<Span className={'text-font03 text-body3'}>(amount)</Span>
                </Text>
                <Text>Date</Text>
            </TableHeader>
            {data
                ?.sort((a, b) => b.created_at - a.created_at)
                ?.map(item => (
                    <TableItem
                        key={item?.key_id}
                        className={
                            'grid-cols-[1fr_130px_100px_170px] gap-x-[10px] md:grid-cols-3 md:gap-y-[20px] md:items-start md:px-0 sm:grid-cols-1'
                        }>
                        <div
                            className={
                                'flex items-center gap-x-[5px] truncate md:justify-center md:col-span-3 sm:col-span-1'
                            }>
                            <WizImage src={item?.logo} containerClassName={'w-[24px]'} />
                            <Text className={'text-ti2 truncate'}>{item?.symbol}</Text>
                        </div>
                        <div className={'md:space-y-[5px]'}>
                            <Text className={'hidden md:block text-ti3 text-font02 text-center'}>Type</Text>
                            <div className={'flex items-center gap-x-[10px] md:justify-center'}>
                                <Text
                                    className={`text-ti3 py-[3px] px-[7px] rounded-[5px] ${
                                        item?.side === 'buy'
                                            ? 'bg-tag_green_light text-font_green'
                                            : 'bg-tag_red_light text-font_red'
                                    }`}>
                                    {item?.side === 'buy' ? '매수' : '매도'}
                                </Text>
                                <Text>{item?.type === 'limit' ? '지정가 매매' : '스탑 로스'}</Text>
                            </div>
                        </div>
                        <div className={'md:space-y-[5px]'}>
                            <Text className={'hidden md:block text-ti3 text-font02 text-center'}>
                                Price<Span className={'text-font03 text-body_comm'}>(Amount)</Span>
                            </Text>
                            <div className={'md:text-center'}>
                                <Text className={'text-ti2'}>{floorBalance(item?.price, 1000)}</Text>
                                <Text className={'text-font03 text-body3'}>({displayAmount(item?.amount)})</Text>
                            </div>
                        </div>
                        <div className={'md:space-y-[5px]'}>
                            <Text className={'hidden md:block text-ti3 text-font02 text-center'}>Date</Text>
                            <Text className={'text-font02 md:text-center'}>
                                {new Date(item?.created_at * 1000).toLocaleString()}
                            </Text>
                        </div>
                    </TableItem>
                ))}
        </ContainerLayout>
    )
}

export default OpenOrderContainer
